import React from 'react';
import UserDetail from '../../components/UserDetail';
import Users from './Users';

const CreateWrapper = (props) => <UserDetail {...props} actionType="create" />;
const EditWrapper = (props) => <UserDetail {...props} actionType="edit" />;

const resource = {
  list: Users,
  create: CreateWrapper,
  edit: EditWrapper,
};

export default resource;
